<template>
  <Head title="Privacidade" />
    <RegisterLayout :showLogo="false" title="Privacidade">
      <div class="px-6">
        <p class="pb-2">Sobre a Privacidade:</p>
        <p class="pb-2">Etapa 3/3</p>
      </div>
    <article>
        <div class="sm:px-5 h-[535px] overflow-y-scroll">
            <!-- <HeadingGuest title="Regulamento" /> -->
            <!-- <p class="pb-2">Sobre a Privacidade:</p> -->
            <!-- {{$page}} -->
            <form @submit.prevent="submit">
                <ul class="grid gap-5 pt-4">
                    <li class="py-6 px-4 bg-gray-100">
                        <div v-html="term.text"></div>
                    </li>
                    <div class="flex" v-for="(termsAccept, index) in term.termAccepts" :key="index">
                        <input class="hover:bg-gray-600 self-start mt-1 mr-2" type="radio" :id="'acceptTerms-' + index " :name="'acceptTerms-' + index " :value="termsAccept.id" v-model="acceptTerms[termsAccept.id]">
                        <label  :for="'acceptTerms-' + index ">{{ termsAccept.text }}</label>
                    </div>
                    <li>
                    <Button
                        @click.prevent="submit()"
                        :enabled="allIsValid"
                    >
                        Avançar
                    </Button>
                    </li>
                </ul>
            </form>
        </div>
    </article>
    <ValidationErrors :errors="errors" />
  </RegisterLayout>
</template>

<script>
import RegisterLayout from "@/Layouts/Register.vue";
import Input from "@/Components/UI/Form/Input.vue";
import Label from "@/Components/Label.vue";
import Button from "@/Components/Button.vue";
import ValidationErrors from "@/Components/ValidationErrors.vue";
import { Head, Link } from "@inertiajs/inertia-vue3";
import { Inertia } from '@inertiajs/inertia'
import HeadingGuest from "@/Components/UI/Texts/HeadingGuest.vue";

export default {

  components: {
    Input,
    Label,
    Button,
    ValidationErrors,
    Head,
    Link,
    RegisterLayout,
    HeadingGuest,
  },

  props: {
    term: Object,
    acceptTerms: {
      type: Object,
      default: {}
    },
  },

  data() {
    return {
      errors: [],
    };
  },

  computed: {
      allIsValid: function() {
        const terms = JSON.parse(
            JSON.stringify(this.acceptTerms)
        );

        return Object.values(terms).filter(accepted => !accepted).length === 0
      }
  },

  methods: {
    submit() {
        this.errors = [];

        const terms = JSON.parse(
            JSON.stringify(this.acceptTerms)
        );

        if(Object.values(terms).filter(accepted => !accepted).length === 0) {

            sessionStorage.setItem('acceptPrivacy', JSON.stringify(this.acceptTerms));
            this.$inertia.get("/register/register-participante");
        } else {
            this.errors.push('Aceite os termos para prosseguirmos')
        }
    },
  },
};
</script>
